<template>
  <div v-if="card">
    <div class="payment card">
      <div class="content" :class="[{ 'active' : cardLoaded }, cardBrand]">
        <div class="brand-logo">
          <img class="ui image" :src="cardBrandImage">
        </div>
        <div class="cardnumber">
          <span>••••</span>
          <span>••••</span>
          <span>••••</span>
          <span>{{ last4Digits }}</span>
        </div>

        <div class="cardinfo">
          <div class="cardholder">
            <div class="pay-label">{{ $t('components.card.card_holder') }}</div>
            <div class="pay-header">{{ cardHolderName }}</div>
          </div>
          <div class="expirydate">
            <div class="pay-label">{{ $t('components.card.expires') }}</div>
            <div class="pay-header">{{ cardExpires }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else-if="!card && cardType.length > 0 && cardType === 'mobile_pay'" class="payment card">
    <div class="content MOBILEPAY active">
      <div class="center-block">
        <img class="ui image" :src="mobilePayImage" alt="Mobile Pay">
      </div>
    </div>
  </div>
  <div v-else-if="!card && cardType.length > 0 && cardType === 'vipps'" class="payment card">
    <div class="content VIPPS active">
      <div class="center-block">
        <img class="ui image" :src="vippsImage" alt="Vipps">
      </div>
    </div>
  </div>
  <div v-else-if="!card && cardType.length === 0" class="payment card">
    <div class="content active">
      <div class="center-block no-card">
        {{ $t('components.card.no_card') }}
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import mobilepay from '../../assets/images/payment_methods/mobilepay.png'
  import vipps from '../../assets/images/payment_methods/vipps.png'
  import dankortlogo from '../../assets/images/cardlogos/dankortlogo.png'
  import mastercardlogo from '../../assets/images/cardlogos/mastercardlogo.png'
  import visalogo from '../../assets/images/cardlogos/visawhite.png'
  import maestrologo from '../../assets/images/cardlogos/maestrologo.png'

  export default {
		name: 'Card',

		props: {
			card: {
				required: false,
        default: null,
				type: Object
			},
      cardType: {
        required: false,
        default: '',
        type: String
      }
		},

		data () {
			return {
				cardLoaded: false
			}
		},

		mounted () {
			if (this.card) {
				// Show fancy card loading animation
				setTimeout(() => {
					this.cardLoaded = true
				}, 100)
			}
		},

		computed: {
      activeMerchant() {
        return this.$store.getters.activeMerchant;
      },

			cardBrand () {
        return this.card ? this.card.paymentMethod.toUpperCase() : ''
			},

			cardBrandImage () {
				switch (this.cardBrand) {
					case 'DANKORT':
						return dankortlogo
					case 'MASTER':
          case 'MASTERCARD':
					case 'MASTERDEBIT':
						return mastercardlogo
					case 'VISA':
					case 'VISADEBIT':
					case 'VISAELECTRON':
						return visalogo
					case 'MAESTRO':
						return maestrologo
				}
			},

      mobilePayImage () {
        return mobilepay
      },

      vippsImage () {
        return vipps
      },

			cardHolderName () {
        return '**** ****'
			},

			cardExpires () {
				return moment(this.card.expires).format('MM/YY')
			},

			last4Digits () {
        return this.card.maskedPan.slice(-4)
			}
		},

		methods: {}
	}
</script>

<style scoped>
  .no-card {
    font-size: 20px;
    font-weight: bold;
  }
  .payment.card .content.MOBILEPAY.active, .payment.card .content.VIPPS.active {
    background-color: #f8f8f8;
    border-top: 1px solid #ccc !important;
    border-radius: 10px !important;
  }
  .payment.card .content.MOBILEPAY.active img, .payment.card .content.VIPPS.active img {
    height: auto;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/payment/Card.vue